import TypingIndicator from './container';

export default TypingIndicator;
